<template>
  <div class="mx-auto my-5">
    <div class="account-wall mb-3">
      <h1 class="text-center login-title">Reset Password</h1>
      <b-form class="form-login" ref="ruleForm">
        <b-form-input v-model="password" type="password" placeholder="New Password (*)"
          name="password" v-validate="'required|alpha_dash|min:6'" 
          :class="{'form-control':true, 'is-invalid':errors.has('password'), 'mb-3':true}">
        </b-form-input>
        <b-form-input v-model="password1" type="password" placeholder="Confirm New Password (*)"
          name="password_confirmation" v-validate="'required|confirmed:password'"
          data-vv-as="password"
          :class="{'form-control':true, 'is-invalid':errors.has('password_confirmation'), 'mb-4':true}">
        </b-form-input>
        <b-button size="lg" variant="primary" type="submit" @click.prevent="resetPassword" block>
            Submit</b-button>
      </b-form>
    </div>
    <b-alert v-show="errors.has('password')" show variant="warning">{{ errors.first('password') }}</b-alert>
    <b-alert v-show="errors.has('password_confirmation')" show variant="warning">{{ errors.first('password_confirmation') }}</b-alert>
  </div>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      password1: ''
    }
  },

  methods: {
    resetPassword () {
      this.$validator.validateAll()
      .then(result => {
        if (!result) {
          return
        }
        let token = this.$route.query.token
        this.$http.post('/user/reset_password', {
          token: token,
          new_password: this.password
        })
        .then((res) => {
          // FIXME: ElementUI is required to use $message, need to find a replacement
          this.$message(res.data.message)
          this.$router.push('/login')
        })
        .catch((error) => {
          this.$message(error.response.data.message)
        })
      })
    }

  },

  mounted () {
    console.log(this.$auth.redirect())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
